import './components/waiting.js'
import './components/locoscrollAndGsap.js'
import './components/swiper.js'
import './components/filterSearch.js'
import './components/filterSearchActus.js'
import './components/filterSearchRecrut.js'
import './components/groupe.js'
import './components/customSelect.js'
import './components/customSelectLieu.js'
import './components/navRwd.js'
import './components/webpDetect.js'

// console.log('dev works!!');  // dev TEST



